document.addEventListener("DOMContentLoaded", function () {
    const logo = document.getElementById("cflogo");
    const logoMobile = document.getElementById("cflogomobile");

    // Speel automatisch af wanneer pagina volledig is geladen
    logo.addEventListener("ready", () => {
        setTimeout(() => {
            logo.play();
          }, 1000);
    });

    // Speel automatisch af wanneer pagina volledig is geladen
    logoMobile.addEventListener("ready", () => {
        setTimeout(() => {
            logoMobile.play();
          }, 1000);
    });

    // Hover: afspelen, maar maximaal 1x per hover
    let hoverPlayed = false;
    logo.addEventListener("mouseenter", () => {
      if (!hoverPlayed) {
        logo.seek(0);            // ← reset naar begin
        logo.setDirection(1);
        logo.play();
        hoverPlayed = true;

        // Reset hoverPlayed na animatie zodat het opnieuw kan afspelen bij volgende hover
        logo.addEventListener("complete", () => {
          hoverPlayed = false;
        }, { once: true });
      }
    });
    logoMobile.addEventListener("mouseenter", () => {
        if (!hoverPlayed) {
            logoMobile.seek(0);            // ← reset naar begin
            logoMobile.setDirection(1);
            logoMobile.play();
          hoverPlayed = true;
  
          // Reset hoverPlayed na animatie zodat het opnieuw kan afspelen bij volgende hover
          logoMobile.addEventListener("complete", () => {
            hoverPlayed = false;
          }, { once: true });
        }
      });
  });

  function restartAnimation(animation) {
    animation.seek(0);
    animation.setDirection(1);
    animation.play();
}
